document.addEventListener('DOMContentLoaded', function () {

  // --- Variant / size pickers (works for featured-product AND main-product) ---
  document.querySelectorAll('.product').forEach(function (productEl) {
    var variantsJson = productEl.getAttribute('data-product-json');
    if (!variantsJson) return;

    var variants;
    try {
      variants = JSON.parse(variantsJson.replace(/&quot;/g, '"'));
    } catch (e) {
      try { variants = JSON.parse(variantsJson); } catch (e2) { return; }
    }

    var form = productEl.querySelector('.variant-form');
    var hiddenIdInput = productEl.querySelector('.variant-id-input');
    var sizeButtons = productEl.querySelectorAll('.size-btn');
    var addBtn = productEl.querySelector('.add-cart');
    var stockNote = productEl.querySelector('.stock-note');
    var priceBlock = productEl.querySelector('.price-current');

    var selectedValue = null;

    function findVariant(value) {
      return variants.find(function (v) {
        return v.option1 === value || v.title === value;
      });
    }

    function formatMoney(cents) {
      return (cents / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    }

    sizeButtons.forEach(function (btn) {
      var value = btn.getAttribute('data-value');
      var variant = findVariant(value);
      if (variant && variant.available === false) {
        btn.classList.add('disabled');
      }

      btn.addEventListener('click', function () {
        if (btn.classList.contains('disabled')) return;
        sizeButtons.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        selectedValue = value;

        var variant = findVariant(value);
        if (variant) {
          if (hiddenIdInput) hiddenIdInput.value = variant.id;
          if (priceBlock) priceBlock.textContent = formatMoney(variant.price);
          if (addBtn) {
            addBtn.disabled = !variant.available;
            addBtn.textContent = variant.available ? 'Ajouter au panier' : 'Épuisé';
          }
          if (stockNote) stockNote.textContent = 'Taille ' + value + ' sélectionnée.';
        }
      });
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        if (sizeButtons.length && !selectedValue) {
          e.preventDefault();
          if (stockNote) stockNote.textContent = "Choisis une taille avant d'ajouter au panier.";
        }
      });
    }

    // --- Thumbnail gallery ---
    var mainImg = productEl.querySelector('.main-image img');
    productEl.querySelectorAll('.thumb-btn').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (mainImg) mainImg.src = thumb.getAttribute('data-full');
      });
    });
  });

});
